module.exports = __webpack_public_path__ + "media/images/pages/fcr/effectiveness-6f75a2e30646c43cd430e4d9b78758d5.png";